import { PermissionsEnum } from "@/auth/interfaces";
import { a11yProps, sizeTab, useCheckPermissions } from "@/shared";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { CustomTabPanel } from "../..";
import PreventaActualizacionContratoPage from "../preventa/page/preventa-contrato/PreventaActualizacionContratoPage";
import PreventaActualizarIAPage from "../preventa/page/preventa-contrato/PreventaActualizarIAPage";

const PendamientoActualizacionPage = () => {
  useCheckPermissions(PermissionsEnum.api_view_preagendamiento);
  const [valueTab, setValueTab] = useState(0);

  
  return (
    <SingleTableBoxScene title={"Pendiente Actualización"} visibleReport={true}>
      <Box
        sx={{
          bgcolor: "background.paper",
          maxWidth: sizeTab,
          paddingBottom: 2,
        }}
      >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={"Contratos con Novedades"} {...a11yProps(0)} />
          <Tab label={"Revisados por IA"} {...a11yProps(0)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <PreventaActualizacionContratoPage />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <PreventaActualizarIAPage />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );
};

export default PendamientoActualizacionPage;
